<template>
    <BreadCrumb PageTitle="Liste des validations Check" />
    <ListeValidationCheck/>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ListeValidationCheck from "@/components/ValidationCheck/ListeValidationCheck.vue";



export default defineComponent({
    name: "ListeValidationCheckPage",
    components: {
        BreadCrumb,
        ListeValidationCheck,
    },
});
</script>